import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { BasePage } from "pages/BasePage";
import { DefaultEventTextStore } from "./DefaultEventTextStore";
import { AllStores } from "stores/all";
import { Panel, Button } from "@countysuite/ui";
import { DefaultEventTextTable } from "./DefaultEventTextTable";

interface Props {
  eventTextStore: DefaultEventTextStore;
}

const DefaultEventTextPage: React.FC<Props> = ({ eventTextStore }) => {
  useEffect(() => {
    eventTextStore.fetchAll();
  }, [eventTextStore]);

  const panelButtons = (
    <>
      <Button
        onClick={eventTextStore.resetCurrent}
        disabled={!eventTextStore.currentText.id}
      >
        Clear Selection
      </Button>
      <Button color="success" onClick={eventTextStore.saveCurrent}>
        {eventTextStore.currentText.id ? "Update" : "Create"}
      </Button>
    </>
  );

  return (
    <BasePage>
      <Panel title="Default Event Texts" buttons={panelButtons}>
        <DefaultEventTextTable
          rows={eventTextStore.tableRows}
          currentRow={eventTextStore.currentText}
          selectRow={eventTextStore.selectRow}
        />
      </Panel>
    </BasePage>
  );
};

function mapStores(stores: AllStores): any {
  return { eventTextStore: stores.eventTextStore };
}

export default inject(mapStores)(observer(DefaultEventTextPage));
